// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3PLNr","empty":"ModalGraph_empty__tTMA8"};